module.exports = __webpack_public_path__ + "img/66.10.pH.fcb7d9de.png";